import { atomFamily } from "jotai/utils";
import { createPersistedAtom } from "./utils/createPersistedAtom";
import { createDerivedSessionAtom } from "./utils/createDerivedSessionAtom";

export const sessionRegistrationAtom = atomFamily((sessionId: string) => createPersistedAtom(`registration-${sessionId}`, ""));
export const registrationAtom = createDerivedSessionAtom<string>(sessionRegistrationAtom);
